// extracted by mini-css-extract-plugin
export default {"link":"requests_link__rDsfz"};